import { OptionSeparator } from "@resource/atlas";

export default function Line() {
  return <OptionSeparator className="!m-0 !min-w-full" />;
}
